import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";
import { ChangeUserInfoCpModalComponent } from "../edit-cp-user-info/edit-cp-user-info-modal";
import { AddUserCpModalComponent } from "../add-cp-user-info/add-cp-user-info-modal";

@Component({
  selector: "list-cp-users-modal",
  templateUrl: "list-cp-users-modal.html",
  providers: [SummaryServiceProvider]
})
export class ListCPUsersModalComponent {
  data;
  password: any;
  cpUsersList: any = [];
  updateError: any = false;

  constructor(
    private plt: Platform,
    public params: NavParams,
    public modalCtrl: ModalController,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
    this.getCPUserAccounts();
  }

  editUserInfo(data) {
    const modal = this.modalCtrl.create(ChangeUserInfoCpModalComponent, {
      data: data
    });
    modal.onDidDismiss(data => {
      this.getCPUserAccounts();
    });
    modal.present();
  }

  addCPUser() {
    const modal = this.modalCtrl.create(AddUserCpModalComponent, {
      data: this.data.id
    });
    modal.onDidDismiss(data => {
      this.getCPUserAccounts();
    });
    modal.present();
  }

  async getCPUserAccounts() {
    let res: any = await this.summaryService.getMerchantsAccountsInfo(
      `collectionPointDto.id=${this.data.id}`
    );
    this.cpUsersList = res.data.content;
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/list-cp-users-modal/list-cp-users-modal.ts